var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',_vm._b({attrs:{"disabled":!_vm.tooltip},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({staticClass:"d-inline-block"},on),[_c('v-btn',_vm._b({staticClass:"rounded-btn",attrs:{"min-width":"120","large":""},on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',_vm.$attrs,false),[_vm._t("default")],2)],1)]}}],null,true)},'v-tooltip',( _obj = {}, _obj[_vm.direction] = true, _obj ),false),[_c('div',[_vm._t("tooltip")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }